import { render } from "./ModalTransactionDetail.vue?vue&type=template&id=72cd883f&scoped=true"
import script from "./ModalTransactionDetail.vue?vue&type=script&lang=js"
export * from "./ModalTransactionDetail.vue?vue&type=script&lang=js"

import "./ModalTransactionDetail.vue?vue&type=style&index=0&id=72cd883f&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cd883f"]])

export default __exports__